import axios from "../axios-auth";

export const countryService = {
    getCountryList,
    getCountryDetail,
    saveCountry,
    getCountryByStatus,
}

function getCountryList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/countries", { params });
}

function getCountryDetail(id) {
    return axios.get("/auth/country/" + id);
}

function saveCountry(country) {
    if (!country.id) {
        // new country
        return axios.post("/auth/country", country);
    } else {
        // edit
        return axios.put("/auth/country", country);
    }
}

function getCountryByStatus(status) {
    return axios.get("/auth/countries-by-status/" + status);
}
